// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"Global_pageHeader__3R4P2","pageContent":"Global_pageContent__1s2xn","modalDesc":"Global_modalDesc__1RKk3"};